import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Award, Linkedin, ArrowRight } from "lucide-react";

export default function CounsellorCard({ c }) {
  const navigate = useNavigate();
  const request = () => {
    navigate("/", { state: { scrollTo: "contact", requestedCounsellor: c.name } });
  };
  return (
    <div className="bg-white rounded-2xl cc-shadow-card overflow-hidden flex flex-col group hover:-translate-y-1 transition-transform duration-300">
      <div className="h-44 bg-gradient-to-br from-[#eaf3ff] to-[#dbeafe] flex items-center justify-center overflow-hidden">
        {c.photo ? (
          <img src={c.photo} alt={c.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
        ) : (
          <div className="w-20 h-20 rounded-full bg-[#16244F] text-white flex items-center justify-center font-head text-3xl font-bold">
            {c.name?.charAt(0)}
          </div>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-head text-lg font-semibold text-[#16244F]">{c.name}</h3>
        {c.specialization && (
          <span className="mt-1 inline-block text-sm text-[#2b8cf0] font-semibold">{c.specialization}</span>
        )}
        <div className="mt-3 space-y-1.5 text-sm text-[#5a6274]">
          {c.qualification && (
            <div className="flex items-center gap-2"><Award size={15} className="text-[#F58220]" /> {c.qualification}{c.experience ? ` \u00b7 ${c.experience} yrs` : ""}</div>
          )}
          {c.city && <div className="flex items-center gap-2"><MapPin size={15} className="text-[#F58220]" /> {c.city}</div>}
        </div>
        <div className="mt-5 flex items-center gap-3">
          <button onClick={request} className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold text-sm px-4 py-2.5 rounded-lg transition-colors">
            Request <ArrowRight size={15} />
          </button>
          {c.linkedin && (
            <a href={c.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-200 flex items-center justify-center text-[#16244F] hover:bg-[#16244F] hover:text-white transition-colors" aria-label="LinkedIn">
              <Linkedin size={18} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
